import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DataTypeProvider, } from '@devexpress/dx-react-grid'
import Input from '@material-ui/core/Input';
import PhoneFormat from '../format/PhoneFormat.js';
import Tooltip from '@material-ui/core/Tooltip';

export default class PhoneTypeProvider extends Component {
  render() {
    return(
      <DataTypeProvider
        for={this.props.for}
        formatterComponent={({ value }) =>
          <Tooltip title={"Click to copy!"} placement="top-start">
            <PhoneFormat
              style={{ cursor: "pointer" }}
              displayType='text'
              value={value}
              onClick={() => {
                navigator.clipboard.writeText(value);
              }}
            />
          </Tooltip>
        }
        editorComponent={({ column, row, value, onValueChange }) =>
          this.props.editable || !row ?
          <Input
            style={{ margin: 8 }}
            fullWidth
            placeholder={!row ? "Filter..." : ""}
            value={value || ''}
            onChange={event => onValueChange(event.target.value.replace(/\D/g,''))}
            inputComponent={PhoneFormat}
          /> :
          <div/>
        }
      />
    );
  }
}

PhoneTypeProvider.defaultProps = {
  editable: true,
};

PhoneTypeProvider.propTypes = {
  for: PropTypes.array.isRequired,
  editable: PropTypes.bool,
}
